Object.defineProperty(exports, "__esModule", {
  value: true
});

var interpolatePath_1 = require("./operators/interpolatePath");

var path_1 = require("./path");

function interpolate(paths, options) {
  return interpolatePath_1.interpolatePath(paths.map(function (path) {
    return new path_1.Path(path);
  }), options || {});
}

exports.interpolate = interpolate;